<template>
  <AuthLayout>
    <template #header>
      <h1 class="text-[32px] font-semibold -mb-1.5">Add Personal Details</h1>
    </template>

    <div class="w-full">
      <!-- Form inputs -->
      <div class="flex flex-col w-full mb-8 gap-3">
        <div>
          <BaseInput
            v-model="authStore.signup_fields.first_name"
            label="First Name"
            field_type="string"
            field_name="first_name"
            place_holder="Enter your first name"
            variant="secondary"
            is_required
            @keydown.enter="handleNextStep"
          />
        </div>
        <div>
          <BaseInput
            v-model="authStore.signup_fields.last_name"
            label="Last Name"
            field_type="string"
            field_name="last_name"
            place_holder="Enter your last name"
            variant="secondary"
            is_required
            @keydown.enter="handleNextStep"
          />
        </div>

        <div>
          <BaseInput
            v-model="authStore.signup_fields.phone"
            label="Phone Number"
            field_type="string"
            field_name="phone"
            place_holder="(xxx) xxx-xxxx"
            variant="secondary"
            is_required
            @keydown.enter="handleNextStep"
          />
        </div>
      </div>
      <!-- CTA Buttons -->
      <Button
        @click="handleNextStep"
        size="md"
        variant="primary-grey"
        class="w-full max-lg:hidden"
        @keydown.enter="handleNextStep"
      >
        <template #label>Next</template>
      </Button>
    </div>

    <template #cta>
      <Button @click="handleNextStep" size="md" variant="primary-grey" class="w-full">
        <template #label>Next</template>
      </Button>
    </template>
  </AuthLayout>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useAuthStore, useSchemaStore } from "@/stores";
import { BaseInput, Button, Icon } from "@/components";
import AuthLayout from "./AuthLayout.vue";

const router = useRouter();
const authStore = useAuthStore();
const schemaStore = useSchemaStore();

onMounted(() => {
  window.scrollTo(0, 0);
  if (!authStore.signup_fields.email) {
    router.push("/sign-up");
  }
});

const isFormValid = computed(() => {
  return (
    authStore.signup_fields.first_name &&
    authStore.signup_fields.last_name &&
    authStore.signup_fields.phone &&
    authStore.signup_fields.phone.length === 14
  );
});

const authSchema = [
  {
    field_name: "first_name",
    field_type: "string",
    is_required: true,
    label: "First Name",
  },
  {
    field_name: "last_name",
    field_type: "string",
    is_required: true,
    label: "Last Name",
  },
  {
    field_name: "phone",
    field_type: "string",
    is_required: true,
    label: "Phone Number",
  },
];

function handleNextStep() {
  authStore.signup_fields.first_name = authStore.signup_fields.first_name?.trim();
  authStore.signup_fields.last_name = authStore.signup_fields.last_name?.trim();
  authStore.signup_fields.phone = authStore.signup_fields.phone?.trim();

  const result = schemaStore.validateFields(
    {
      first_name: authStore.signup_fields.first_name,
      last_name: authStore.signup_fields.last_name,
      phone: authStore.signup_fields.phone,
    },
    authSchema,
    null,
    true
  );

  if (!result.proceed) {
    return;
  }

  authStore.active_signup_step = 3;
  router.push("/sign-up/set-password");
}

function handleBack() {
  authStore.active_signup_step = 1;
  router.back();
}
</script>
